/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 10/15/2019
 *
 */

import React from 'react';
import Header from '../components/common/header/header';
import MainContent from './Main-content/MainContent';
import Alert from "../components/generic/alerts/Alert";
import TableColumnViewer from "../components/generic/modals/tableColumnViewer";
import Warning from "../components/generic/modals/warnings/warning";
import EventEmitter from "../eventEmmiters/EventEmitter";
import Sidebar from "../components/common/sidebar/sidebar";
import Loader from "../components/generic/loader/loader";
import UrlViewer from "../components/generic/modals/urlViewer";

class MainLayout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openLoader: false,
            openAlert: false,
            type: '',
            isDisplayAlertIcon: false,
            alertMessage: '',
            alertTitle: ''
        };

        EventEmitter.on('setAlert', this.setAlert);
        EventEmitter.on('setLoader', this.setLoader);
    }

    componentWillUnmount = () => {
        EventEmitter.off('setAlert', this.setAlert);
        EventEmitter.off('setLoader', this.setLoader);
    };

    setAlert = (event) => {
        const newState = Object.assign({}, this.state);

        newState.openAlert = event.openAlert;
        newState.type = event.type;
        newState.isDisplayAlertIcon = event.isDisplayAlertIcon;
        newState.alertMessage = event.alertMessage;
        newState.alertTitle = event.alertTitle;
        this.setState(newState);

        setTimeout(() => {
            newState.openAlert = false;
            this.setState(newState);
        }, 5000);
    };

    setLoader = (event) => {
        const newState = Object.assign({}, this.state);
        newState.openLoader = event;
        this.setState(newState);
    };

    render() {
        return(
            <div>
                <TableColumnViewer />
                <UrlViewer />
                <Warning/>
                {this.state.openLoader &&
                    <Loader />
                }
                {this.state.openAlert &&
                    <Alert alertMessage={this.state.alertMessage} alertTitle={this.state.alertTitle}
                           type={this.state.type} icon={this.state.isDisplayAlertIcon}/>
                }

                <Header />
                <Sidebar/>
                <MainContent/>
            </div>
        )
    }
}

export default MainLayout;
